import config from "../config";

const S3Loader = ({ src }) =>
  `${config.COMPONENT_BUCKET}${config.ASSET_PATH}/${src}`;

export default {
  S3Loader,
};
